import { render, staticRenderFns } from "./ProductAdminBar.vue?vue&type=template&id=3e14c2a5"
import script from "./ProductAdminBar.vue?vue&type=script&lang=js"
export * from "./ProductAdminBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports